<template>
  <div
    ref="teamMemberCardRef"
    class="team-member-card d-flex flex-column gr-4"
  >
    <div class="d-flex gc-4">
      <v-img
        class="flex-grow-0 rounded-circle"
        lazy-src="/static/_v1/pd/pictures/stubs/person-photo.png"
        :alt="`${transDynamic(teamMember, `first_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `last_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `position,${language},${needTranslate}`)}`"
        :src="teamMember.photo.url"
        width="40"
        height="40"
      />
      <div>
        <p class="text-body-1 text--text">
          {{ transDynamic(teamMember, `first_name,${language},${needTranslate}`) }}
          {{ transDynamic(teamMember, `last_name,${language},${needTranslate}`) }}
        </p>
        <p class="text-body-2 text-info--text">
          {{ transDynamic(teamMember, `position,${language},${needTranslate}`) }}
        </p>
      </div>
    </div>
    <div
      ref="descriptionHtmlRef"
      class="team-member-card__html text-body-1 text--text"
      :class="isExpandedDescription ? 'team-member-card__html--expanded' : ''"
      v-html="transDynamic(teamMember, `description,${language},${needTranslate}`)/* eslint-disable-line vue/no-v-html */"
    />
    <button
      type="button"
      class="text-body-1 align-self-start cursor-pointer"
      :class="isExpandedDescription ? 'text--text' : 'primary--text'"
      @click="handleClickExpandDescription"
    >
      {{ isExpandedDescription ? t('Скрыть', options) : t('Показать всё', options) }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore } from 'src/store'
import type { ContextStore, TeamMember } from 'src/components/pages/info/about-us/index/types'

const { t, language } = I18NextVue
const options = { ns: language }
const { context }: ContextStore = useContextStore()
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  adminkaUrl?: string
  teamMember: TeamMember
}>()

const isExpandedDescription = ref(false)
const teamMemberCardRef = ref()

async function handleClickExpandDescription() {
  isExpandedDescription.value = !isExpandedDescription.value

  if (!isExpandedDescription.value) {
    await nextTick()
    teamMemberCardRef.value?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';
@import '~www/themes/doctors/common/typography';

.team-member-card {
  &__html {
    -webkit-line-clamp: 6;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;

    &--expanded.team-member-card__html {
      -webkit-line-clamp: none;
    }
  }

  &__html > :deep(*:not(b ~ span, b)) {
    margin-bottom: 12px !important;
  }

  &__html > :deep(ul),
  &__html > :deep(ol) {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    list-style-type: none;
  }

  &__html > :deep(b) {
    font-weight: $weight-medium;
  }
}
</style>
